import { createApiRef } from '@backstage/core-plugin-api';

export type BitbucketProjectOption = {
  value: string;
  label: string;
  description?: string;
  metadata: {
    workspace: string;
    projectKey: string;
    projectName: string;
    uuid: string;
  };
};

export type BitbucketProjectsResponse = {
  projects: BitbucketProjectOption[];
  total: number;
  cached: boolean;
  timestamp: string;
};

/**
 * API interface for Bitbucket Projects
 */
export interface BitbucketProjectsApi {
  /**
   * Fetch Bitbucket projects for a workspace
   * @param workspace - Bitbucket workspace slug
   * @param refresh - If true, bypass cache and fetch fresh data
   */
  getProjects(workspace: string, refresh?: boolean): Promise<BitbucketProjectsResponse>;
}

/**
 * API reference for Bitbucket Projects
 */
export const bitbucketProjectsApiRef = createApiRef<BitbucketProjectsApi>({
  id: 'plugin.bitbucket-projects.service',
});
